import React from 'react';
import { motion } from 'framer-motion';
interface GeoGridProps {
  width: number;
  height: number;
  mode: 'perimeter' | 'area';
  label?: string;
}
export function GeoGrid({
  width,
  height,
  mode,
  label
}: GeoGridProps) {
  const cellSize = 20;
  const padding = 40;
  return <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-1110">
      {label && <div className="text-sm font-medium text-slate-700 mb-3 text-center" data-id="element-1111">
          {label}
        </div>}
      <div className="flex justify-center" data-id="element-1112">
        <svg width={width * cellSize + padding * 2} height={height * cellSize + padding * 2} data-id="element-1113">
          {/* Grid cells */}
          {Array.from({
          length: height
        }).map((_, row) => Array.from({
          length: width
        }).map((_, col) => <motion.rect key={`${row}-${col}`} x={padding + col * cellSize} y={padding + row * cellSize} width={cellSize} height={cellSize} fill={mode === 'area' ? 'rgb(199, 210, 254)' : 'white'} stroke="rgb(148, 163, 184)" strokeWidth="1" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: (row * width + col) * 0.02
        }} data-id="element-1114" />))}

          {/* Perimeter highlight */}
          {mode === 'perimeter' && <motion.rect x={padding} y={padding} width={width * cellSize} height={height * cellSize} fill="none" stroke="rgb(99, 102, 241)" strokeWidth="4" initial={{
          pathLength: 0
        }} animate={{
          pathLength: 1
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} data-id="element-1115" />}

          {/* Dimensions */}
          <text x={padding + width * cellSize / 2} y={padding - 10} textAnchor="middle" className="text-sm font-bold fill-slate-700" data-id="element-1116">
            {width}
          </text>
          <text x={padding - 10} y={padding + height * cellSize / 2} textAnchor="end" dominantBaseline="middle" className="text-sm font-bold fill-slate-700" data-id="element-1117">
            {height}
          </text>
        </svg>
      </div>
      <div className="mt-4 text-center text-sm text-slate-600" data-id="element-1118">
        {mode === 'perimeter' ? <p data-id="element-1119">
            Omtrek = {width} + {height} + {width} + {height} ={' '}
            {2 * (width + height)}
          </p> : <p data-id="element-1120">
            Oppervlakte = {width} × {height} = {width * height}
          </p>}
      </div>
    </div>;
}